module.exports = __webpack_public_path__ + "static/media/mozza-2022-mb_en.e6e19a64.jpg";